import { useTranslation } from 'react-i18next';
import { useQuery } from 'react-query';

import { getSurchargesMaintenanceById } from 'RestAPIs/admin';

import { showSnackbar } from 'components/shared';

const useGetRowData = (rowId?: number | null) => {
  const { t } = useTranslation();
  const { data, isFetching } = useQuery({
    queryKey: ['surchargesMaintenanceId', 'get', rowId],
    queryFn: async () => {
      const { data } = await getSurchargesMaintenanceById(rowId);
      return data;
    },
    enabled: !!rowId,
    onError: () => {
      showSnackbar({
        severity: 'error',
        message: t('fetchError')
      });
    }
  });

  return { isFetching, data };
};

export default useGetRowData;
